/**
 * One choice in a row of «ترتیب» / «فیلتر» pills — a radio that looks like a
 * chip. Wrap a set of them in `role="radiogroup"` with an `aria-label`.
 *
 * Pills rather than a dropdown: every option is visible without a tap, and
 * the chosen one stays on screen as a reminder of why the list looks the way
 * it does.
 */
export default function SortPill({
    checked,
    onChange,
    label,
    aria,
}: {
    checked: boolean
    onChange: () => void
    label: string
    /** spelled-out name; «۷ روز» alone says nothing out loud */
    aria?: string
}) {
    return (
        <button
            type="button"
            role="radio"
            aria-checked={checked}
            aria-label={aria ?? label}
            onClick={onChange}
            className={` shrink-0 rounded-full border px-3 py-1.5 text-[11px] font-bold transition-colors ${
                checked
                    ? ' border-green-1 bg-green-2 text-green-1'
                    : ' border-stroke bg-white text-text-secondary'
            }`}
        >
            {label}
        </button>
    )
}
